import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { parseQueryString } from './../store/history.js';
import Header from './header.js';
import Tabs from './tabs.js';
import Explore from './explore.js';
import Provider from './provider.js';
import AllGames from './all-games.js';
import MyGames from './my-games.js';
import Game from './game.js';
import LiveCasino from './live-casino.js';
import { init } from './../casino/casino.js';
import './../libs/scroll-hidebars.js';
import pixelTracking from './../pixel-tracking/pixel-tracking.js';

class Casino extends Component {
	componentWillMount() {
		pixelTracking.push('casino');
		init();
	}

	render() {
		const query = parseQueryString(this.props.location);
		const url = query && query.url ? query.url : '/casino/explore';
		//const { gameMode, providerName } = this.props.params;
		//const shouldAuthenticate = gameMode && gameMode.toUpperCase() === 'REAL';
		return (
			<div>
				<Header />
				<Tabs />
				<Switch>
					<Route path="/casino/explore" component={Explore} />
					<Route path="/casino/provider/:providerName" component={Provider} />
					<Route path="/casino/all-games" component={AllGames} />
					<Route path="/casino/my-games" component={MyGames} />
					<Route path="/casino/live-casino" component={LiveCasino} />
					<Route path="/casino/game/:gameCode/:gameMode" component={Game} />
					<Route render={() =>
						<Redirect to={url} />
					} />
				</Switch>
			</div>
		);
	}
}

export default Casino;




// WEBPACK FOOTER //
// ./mobile-core/src/components/casino.js